import { Stack } from "expo-router";
import { useState } from "react";
import { View } from "react-native";
import { Button } from "~/components/Button";
import { YesNo } from "~/components/form/radio/YesNo";
import { OnboardingSkip } from "~/components/layout/home/OnboardingSkip";
import { Page } from "~/components/layout/Page";
import { Authorize } from "~/components/permission/Authorize";
import { Nothing } from "~/components/permission/Nothing";
import { Flex, Gap, Margin, Padding } from "~/constants/layout";
import { Font } from "~/constants/typography";
import { useDismiss } from "~/providers/DismissProvider";
import { useFeedback } from "~/providers/FeedbackProvider";
import { useProfile } from "~/providers/ProfileProvider";

export default function PeriodPrediction() {
    const { cycle, updateCycleSettings } = useProfile();
    const { saving, setSaving } = useFeedback();
    const { handleDismiss } = useDismiss();
    const [estimate, setEstimate] = useState<boolean | null>(null);

    const savePrediction = async () => {
        if (saving || estimate === null) {
            return;
        }

        setSaving(true);

        await updateCycleSettings({
            ...cycle,
            estimate,
        }).finally(() => setSaving(false));

        handleDismiss();
    };

    return (
        <>
            <Stack.Screen
                options={{
                    headerLeft: () => <Nothing />,
                    headerRight: () => <OnboardingSkip />,
                }}
            />
            <Authorize ability="update" section="cycle">
                <Page gradient spacer>
                    <View style={[Flex.between, Flex.grow, Padding.bottom_xxl]}>
                        <View style={[Gap.xxl, Padding.horizontal_xs]}>
                            <YesNo
                                title="Would you like to use cycle prediction?"
                                columns={1}
                                value={estimate}
                                onValueChange={setEstimate}
                                labelStyle={[Font.semibold, Font.lg, Margin.bottom_xxs]}
                            />
                        </View>
                        <View style={Padding.horizontal_md}>
                            <Button
                                title="Continue"
                                variant="primary"
                                size="lg"
                                disabled={estimate === null}
                                onPress={savePrediction}
                            />
                        </View>
                    </View>
                </Page>
            </Authorize>
        </>
    );
}
